import React from "react";
import Table from "react-bootstrap/Table";
import CalendarCell from "./calendar-cell";

export default function CalendarGrid({
  weeks,
  currentMonthIndex,
  reservationsMap,
  onCellClick,
}) {
  return (
    <Table bordered responsive className="mb-0 adminlo-calendar-table">
      <thead>
        <tr className="text-center">
          <th>Mo</th>
          <th>Tu</th>
          <th>We</th>
          <th>Th</th>
          <th>Fr</th>
          <th>Sa</th>
          <th>Su</th>
        </tr>
      </thead>
      <tbody>
        {weeks.map((week, weekIndex) => (
          <tr key={weekIndex}>
            {week.map((day, dayIndex) => {
              const dayKey = `${day.getFullYear()}-${String(day.getMonth() + 1).padStart(2, "0")}-${String(day.getDate()).padStart(2, "0")}`;
              const dayReservations = reservationsMap[dayKey] || [];
              return (
                <CalendarCell
                  key={dayKey}
                  day={day}
                  currentMonthIndex={currentMonthIndex}
                  dayIndex={dayIndex}
                  dayReservations={dayReservations}
                  onClick={onCellClick}
                />
              );
            })}
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
